export const deleteRecordingMutation = /* GraphQL */ `
  mutation deleteRecording($recordingKeys: RecordingKeys!) {
    deleteRecording(recording: $recordingKeys)
  }
`;
